import { render, staticRenderFns } from "./AbrFormSectionWrapper.vue?vue&type=template&id=2b9ea71b"
import script from "./AbrFormSectionWrapper.vue?vue&type=script&lang=js"
export * from "./AbrFormSectionWrapper.vue?vue&type=script&lang=js"
import style0 from "./AbrFormSectionWrapper.vue?vue&type=style&index=0&id=2b9ea71b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports